if ( typeof VipNotice !== 'function' ) {

  class VipNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {
      const freeShippingThreshold = Number(this.getAttribute('data-vip-amount'));
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const freeShippingRemaining = cartTotal - Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      const vip_notice_logged = this.getAttribute("vip-notice-logged");
      const vip_logged_in_non_vip = this.getAttribute("vip-logged-in-non-vip");
      const vip_logged_in_non_vip_more = this.getAttribute("vip-logged-in-non-vip-more");
      const vip_enable_vip_promotion = this.getAttribute("vip-enable-vip-promotion");
      const vip_customer = this.getAttribute("vip-customer");
      let shippingMessage = '';
      let shippingSuccess = false

      if(vip_notice_logged == "false"){
        if ( freeShippingRemaining < 0 ) {
          shippingMessage = window.KROWN.settings.locales.vip_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));
  
        } else {
          shippingMessage = window.KROWN.settings.locales.vip_notice_eligible_for_free;
          shippingSuccess = true;
        }
      }else{
         if(vip_customer == "false"){
           if(vip_enable_vip_promotion == "false"){
              shippingMessage = vip_logged_in_non_vip
            }else{
              shippingMessage = vip_logged_in_non_vip_more
            }
          }else{
            this.style.display = "none"
          }
      }

      if ( this.hasAttribute('data-show-alert') ) {
        this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
            ${shippingMessage}
          </div>`;
      } else {
        this.innerHTML = shippingMessage;
      }

    }
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}
		_reInitialize() {
			let th = this;
			if ( this.hasAttribute('cart-page') ) {
				fetch(`?section_id=helper-vip-notice`)
					.then(response => response.text())
					.then(text => {
						const newShippingHTML = new DOMParser()
								.parseFromString(text, 'text/html').querySelector('vip-notice');
						if ( newShippingHTML ) {
							const freeShippingThreshold = Number(newShippingHTML.getAttribute('data-vip-amount'));
							const cartTotal = Number(newShippingHTML.getAttribute('data-cart-total-amount'));
							const freeShippingRemaining = cartTotal - Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
                            const vip_notice_logged = this.getAttribute("vip-notice-logged");
                            const vip_logged_in_non_vip = this.getAttribute("vip-logged-in-non-vip");
                            const vip_logged_in_non_vip_more = this.getAttribute("vip-logged-in-non-vip-more");
                            const vip_enable_vip_promotion = this.getAttribute("vip-enable-vip-promotion");
                            const vip_customer = this.getAttribute("vip-customer");
							let shippingMessage = '';
							let shippingSuccess = false

							if(vip_notice_logged == "false"){
                            if ( freeShippingRemaining < 0 ) {
                              shippingMessage = window.KROWN.settings.locales.vip_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));
                      
                            } else {
                              shippingMessage = window.KROWN.settings.locales.vip_notice_eligible_for_free;
                              shippingSuccess = true;
                            }
                          }else{
                             if(vip_customer == "false"){
                               if(vip_enable_vip_promotion == "false"){
                                  shippingMessage = vip_logged_in_non_vip
                                }else{
                                  shippingMessage = vip_logged_in_non_vip_more
                                }
                              }else{
                                this.style.display = "none"
                              }
                          }
							let allShippingNotice = document.querySelectorAll('vip-notice');
							if ( newShippingHTML.hasAttribute('data-show-alert') ) {
								if(allShippingNotice.length > 0) {
									allShippingNotice.forEach((el) => {
										el.innerHTML = `
											<div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
													${shippingMessage}
											</div>`;
									})
								}
							} else {
								if(allShippingNotice.length > 0) {
									allShippingNotice.forEach((el) => {
										el.innerHTML = shippingMessage;
									})
								}
							}
						}
					});
			}
  }
	}

  if ( typeof customElements.get('vip-notice') == 'undefined' ) {
    customElements.define('vip-notice', VipNotice);
  }

}